import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import classNames from 'classnames';
import React from 'react';

import styles from './DashboardMenuUserProfile.module.css';

interface DashboardMenuUserProfileProps {
  avatarUrl?: string;
  userName: string;
  userEmail: string;
  isCollapsed: boolean;
  onClick?: () => void;
}

const DashboardMenuUserProfile: React.FC<DashboardMenuUserProfileProps> = ({
  avatarUrl,
  userName,
  userEmail,
  isCollapsed,
  onClick,
}) => {
  return (
    <div
      className={classNames(styles.dashboardMenuUserProfile, {
        [styles.dashboardMenuUserProfileCollapsed]: isCollapsed,
        [styles.dashboardMenuUserProfileClickable]: !!onClick,
      })}
      onClick={onClick}
    >
      <Avatar src={avatarUrl ? avatarUrl : undefined} icon={<UserOutlined />} />
      {!isCollapsed && (
        <div className={styles.dashboardMenuUserInfo}>
          <span className={styles.dashboardMenuUserName}>{userName}</span>
          <span className={styles.dashboardMenuUserEmail}>{userEmail}</span>
        </div>
      )}
    </div>
  );
};

export default DashboardMenuUserProfile;
